module.exports = __webpack_public_path__ + "public/images/icon-arrow2.4930f6070cf013cb51b31ad5bfbf392f.svg";